import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useOutletContext } from 'react-router'
import { Link, useParams } from 'react-router-dom'
import AddGroupManagersToGroupsForm from '../../components/userAndGroupForms/AddGroupManagersToGroupsForm/AddGroupManagersToGroupsForm'

import useRoutes from '../../state/useRoutes'

export default React.memo(function AddGroupManagersToGroupPage() {
  const { uuid } = useParams()
  const uuids = useMemo(() => [uuid!], [uuid])

  const { close } = useOutletContext<any>()

  return <AddGroupManagersToGroupsForm groupUuids={uuids} onClose={close} />
})

export function AddGroupManagersToGroupPageBreadcrumb() {
  const { uuid } = useParams()
  const { t } = useTranslation()
  const routes = useRoutes()
  return <Link to={routes.addGroupManagersToGroups.url({ uuid: uuid! })}>{t('manage group.add to group')}</Link>
}
